import lifeIndex from '@/views/life/lifeIndex.vue'
import waterIndex from '@/views/life/water/index.vue'
import electricityIndex from '@/views/life/electricity/index.vue'
import gasIndex from '@/views/life/gas/index.vue'
import phoneIndex from '@/views/life/phone/index.vue'
import televisionIndex from '@/views/life/television/index.vue'

export default {
  path: '/life',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'lifeIndex',
      name: 'lifeIndex',
      component: lifeIndex
    },

    // 水费缴费页面
    {
      path: 'water/index',
      name: 'waterIndex',
      component: waterIndex
    },
    // 电费缴费页面
    {
      path: 'electricity/index',
      name: 'electricityIndex',
      component: electricityIndex
    },
    // 燃气费缴费页面
    {
      path: 'gas/index',
      name: 'gasIndex',
      component: gasIndex
    },
    // 手机话费充值页面
    {
      path: 'phone/index',
      name: 'phoneIndex',
      component: phoneIndex
    },
    // 有线电视费缴费页面
    {
      path: 'television/index',
      name: 'televisionIndex',
      component: televisionIndex
    }
  ]
}
